import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hmTime'
})
export class HmTimePipe implements PipeTransform {

  transform(value: Date): string {
    if(!value)return "00:00";
    let date = new Date(value);
    return `${date.getHours()}:${date.getMinutes()}`;
  }


}
